var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDinbilimleri(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 38,
    viewBox: "0 0 35 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1758 11.4785C34.1758 11.1106 33.8763 10.8112 33.5052 10.8112C33.1341 10.8112 32.8347 11.1106 32.8347 11.4785C32.8347 11.8496 33.1341 12.149 33.5052 12.149C33.8763 12.149 34.1758 11.8496 34.1758 11.4785Z",
    fill: "#148160",
    stroke: "#148160",
    strokeWidth: 0.05,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00651 25.5507C4.00651 24.6849 3.30339 23.985 2.44076 23.985C1.57487 23.985 0.875 24.6849 0.875 25.5507C0.875 26.4134 1.57487 27.1165 2.44076 27.1165C3.30339 27.1165 4.00651 26.4134 4.00651 25.5507Z",
    stroke: "#148160",
    strokeWidth: 1.25,
    strokeMiterlimit: 50,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.875 33.985V5.23499H8.99023C7.96159 5.23499 7.125 6.07157 7.125 7.10022V33.985",
    stroke: "#148160",
    strokeWidth: 1.25,
    strokeMiterlimit: 50,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 31.1497V5.23499",
    stroke: "#148160",
    strokeWidth: 1.25,
    strokeMiterlimit: 50,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 31.485H30.875V36.485H9.625C8.24479 36.485 7.125 35.3652 7.125 33.985C7.125 32.6048 8.24479 31.485 9.625 31.485Z",
    stroke: "#148160",
    strokeWidth: 1.25,
    strokeMiterlimit: 50,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 33.985H7.29425",
    stroke: "#148160",
    strokeWidth: 1.25,
    strokeMiterlimit: 50,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0196 17.4713C17.5515 15.0137 17.9063 11.8789 19.8952 9.82159C16.5358 10.7786 14.5892 14.2812 15.5495 17.6406C16.5098 21 20.0091 22.9466 23.3685 21.9863C24.4362 21.6803 25.4063 21.1009 26.1745 20.3001C23.4304 21.0846 20.4942 19.9258 19.0196 17.4713Z",
    stroke: "#148160",
    strokeWidth: 1.25,
    strokeMiterlimit: 50,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1966 9.88991L23.3099 10.4596C23.3652 10.4889 23.4303 10.4759 23.4759 10.4335L24.3613 9.54486C24.4134 9.48952 24.5046 9.48952 24.5599 9.54486C24.5957 9.58067 24.6087 9.62624 24.599 9.66856L24.4037 10.9088C24.3939 10.9706 24.4264 11.0292 24.4785 11.0585L25.5951 11.6314C25.6634 11.664 25.6895 11.7486 25.6537 11.8203C25.6341 11.8593 25.5951 11.8886 25.5495 11.8951L24.3093 12.0904C24.2507 12.1002 24.1986 12.1458 24.1953 12.2109L24 13.4511C23.9902 13.526 23.9154 13.5813 23.8405 13.5716C23.7949 13.565 23.7559 13.5357 23.7363 13.4934L23.1634 12.3801C23.1341 12.3248 23.0755 12.2955 23.0137 12.3053L21.7734 12.5006C21.6986 12.5136 21.6237 12.4648 21.6107 12.3834C21.6009 12.3411 21.6139 12.289 21.6497 12.2597L22.5352 11.3743C22.5807 11.3287 22.5905 11.2636 22.5612 11.2115L21.9915 10.095C21.9492 10.0234 21.9753 9.93874 22.0436 9.90619C22.099 9.86387 22.1543 9.86387 22.1966 9.88991Z",
    fill: "#148160",
    stroke: "#148160",
    strokeWidth: 0.05,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4 2.10999L5.875 3.98499",
    stroke: "#148160",
    strokeWidth: 1.25,
    strokeMiterlimit: 50,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 0.859985V2.73499",
    stroke: "#148160",
    strokeWidth: 1.25,
    strokeMiterlimit: 50,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M4.625 5.23499H2.75",
    stroke: "#148160",
    strokeWidth: 1.25,
    strokeMiterlimit: 50,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.875 24.61H24.625",
    stroke: "#148160",
    strokeWidth: 1.25,
    strokeMiterlimit: 50,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19 26.485H22.75",
    stroke: "#148160",
    strokeWidth: 1.25,
    strokeMiterlimit: 50,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinbilimleri);
export default __webpack_public_path__ + "static/media/dinbilimleri.9044c405c6d25d25a38f4269c1644851.svg";
export { ForwardRef as ReactComponent };